__turbopack_context__.v({
  "primaryButton": "products-buttons-module__LWpSYa__primaryButton",
  "whiteButton": "products-buttons-module__LWpSYa__whiteButton",
});
